import { render } from "./warehouseMenu.vue?vue&type=template&id=578a2c09"
import script from "./warehouseMenu.vue?vue&type=script&lang=js"
export * from "./warehouseMenu.vue?vue&type=script&lang=js"

import "./warehouseMenu.vue?vue&type=style&index=0&id=578a2c09&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__